var map = {
	"./amenity/advertising_column.svg": "b3bb",
	"./amenity/aerodrome.svg": "5bee",
	"./amenity/arts_centre.svg": "ade6",
	"./amenity/atm.svg": "c855",
	"./amenity/bank.svg": "ba05",
	"./amenity/bar.svg": "4d7b",
	"./amenity/bbq.svg": "2f87",
	"./amenity/bench.svg": "295b",
	"./amenity/bicycle_parking.svg": "3bdf",
	"./amenity/bicycle_repair_station.svg": "d5e2",
	"./amenity/biergarten.svg": "185a",
	"./amenity/boat_rental.svg": "6e1d",
	"./amenity/bureau_de_change.svg": "1f52",
	"./amenity/bus_station.svg": "dca9",
	"./amenity/cafe.svg": "8189",
	"./amenity/car_wash.svg": "b339",
	"./amenity/casino.svg": "c17d",
	"./amenity/charging_station.svg": "848b9",
	"./amenity/cinema.svg": "e6b1",
	"./amenity/community_centre.svg": "be06",
	"./amenity/courthouse.svg": "5ff6",
	"./amenity/dentist.svg": "a379",
	"./amenity/doctors.svg": "81c0",
	"./amenity/drinking_water.svg": "a2be",
	"./amenity/emergency_phone.svg": "bfee",
	"./amenity/entrance.svg": "bbd8",
	"./amenity/excrement_bags.svg": "98617",
	"./amenity/fast_food.svg": "40b7",
	"./amenity/ferry.svg": "0692",
	"./amenity/firestation.svg": "b72e",
	"./amenity/fountain.svg": "479a",
	"./amenity/fuel.svg": "2fce",
	"./amenity/helipad.svg": "e759",
	"./amenity/hospital.svg": "fb50",
	"./amenity/hunting_stand.svg": "fb15",
	"./amenity/ice_cream.svg": "4736",
	"./amenity/internet_cafe.svg": "95fb",
	"./amenity/library.svg": "3db0",
	"./amenity/motorcycle_parking.svg": "a45c",
	"./amenity/nightclub.svg": "bf53",
	"./amenity/parking.svg": "b5ad",
	"./amenity/parking_entrance_multistorey.svg": "0f26",
	"./amenity/parking_entrance_underground.svg": "af73",
	"./amenity/parking_subtle.svg": "fd04",
	"./amenity/parking_tickets.svg": "c7a5",
	"./amenity/pharmacy.svg": "0ffd",
	"./amenity/place_of_worship.svg": "bd4a",
	"./amenity/police.svg": "12f0",
	"./amenity/post_box.svg": "9088",
	"./amenity/post_office.svg": "4c9f",
	"./amenity/prison.svg": "be37",
	"./amenity/pub.svg": "4c56",
	"./amenity/public_bath.svg": "c49b",
	"./amenity/public_bookcase.svg": "c35f",
	"./amenity/public_transport_tickets.svg": "ab5e",
	"./amenity/recycling.svg": "7e04",
	"./amenity/rental_bicycle.svg": "da5d",
	"./amenity/rental_car.svg": "8028",
	"./amenity/restaurant.svg": "69d0",
	"./amenity/shelter.svg": "2ef04",
	"./amenity/shower.svg": "78e7",
	"./amenity/social_facility.svg": "d884",
	"./amenity/taxi.svg": "7a87",
	"./amenity/telephone.svg": "39cb",
	"./amenity/theatre.svg": "d2b8",
	"./amenity/toilets.svg": "c7df",
	"./amenity/town_hall.svg": "f97a",
	"./amenity/vehicle_inspection.svg": "a497",
	"./amenity/veterinary.svg": "7bd4",
	"./amenity/waste_basket.svg": "cf1e8",
	"./amenity/waste_disposal.svg": "719f",
	"./barrier/cattle_grid.svg": "f95a",
	"./barrier/cycle_barrier.svg": "a993",
	"./barrier/full-height_turnstile.svg": "8fb7",
	"./barrier/gate.svg": "6ce1",
	"./barrier/kissing_gate.svg": "b40d",
	"./barrier/level_crossing.svg": "9d42",
	"./barrier/level_crossing2.svg": "c1f1",
	"./barrier/lift_gate.svg": "0efe",
	"./barrier/motorcycle_barrier.svg": "1704",
	"./barrier/stile.svg": "4aa1",
	"./barrier/toll_booth.svg": "9d6b",
	"./generating_patterns/beach.svg": "4987",
	"./generating_patterns/bog.svg": "6c63",
	"./generating_patterns/broadleaved.svg": "2eaa",
	"./generating_patterns/leafless1.svg": "42e0",
	"./generating_patterns/leafless2.svg": "541f",
	"./generating_patterns/mangrove.svg": "7e28",
	"./generating_patterns/marsh.svg": "a553",
	"./generating_patterns/needleleaved.svg": "6c94",
	"./generating_patterns/reed.svg": "511d",
	"./generating_patterns/reef.svg": "5cc3",
	"./generating_patterns/rock.svg": "3937",
	"./generating_patterns/salt-dots-2.svg": "1713",
	"./generating_patterns/scree.svg": "68e3",
	"./generating_patterns/scrub.svg": "5e56",
	"./generating_patterns/swamp.svg": "87aa",
	"./generating_patterns/wetland.svg": "d763",
	"./highway/bus_stop.svg": "7fcc",
	"./highway/elevator.svg": "23de",
	"./highway/ford.svg": "896b",
	"./highway/traffic_light.svg": "738d",
	"./historic/archaeological_site.svg": "0c04",
	"./historic/bust.svg": "1122",
	"./historic/castle.svg": "d3ca",
	"./historic/city_gate.svg": "032f",
	"./historic/fort.svg": "0273",
	"./historic/fortress.svg": "365e",
	"./historic/manor.svg": "bc9b",
	"./historic/memorial.svg": "5f5d",
	"./historic/monument.svg": "7fec",
	"./historic/obelisk.svg": "b031",
	"./historic/palace.svg": "4959",
	"./historic/plaque.svg": "20de",
	"./historic/shrine.svg": "a66e",
	"./historic/statue.svg": "01e5",
	"./historic/stone.svg": "60a6",
	"./leisure/amusement_arcade.svg": "361e",
	"./leisure/beach_resort.svg": "7bf2",
	"./leisure/bird_hide.svg": "5e07",
	"./leisure/bowling_alley.svg": "200e",
	"./leisure/firepit.svg": "caec",
	"./leisure/fishing.svg": "92e1",
	"./leisure/fitness.svg": "2f59",
	"./leisure/golf.svg": "6bea",
	"./leisure/golf_pin.svg": "9c92",
	"./leisure/miniature_golf.svg": "cc72",
	"./leisure/outdoor_seating.svg": "885a",
	"./leisure/playground.svg": "45d4",
	"./leisure/sauna.svg": "b910",
	"./leisure/slipway.svg": "4d8f",
	"./leisure/water_park.svg": "19c4",
	"./man_made/bell_tower.svg": "0565",
	"./man_made/bunker.svg": "0fa0",
	"./man_made/chimney.svg": "3bdd",
	"./man_made/communications_tower.svg": "3762",
	"./man_made/crane.svg": "3d42",
	"./man_made/cross.svg": "cebf",
	"./man_made/generator_wind.svg": "28a6",
	"./man_made/lighthouse.svg": "f718",
	"./man_made/mast.svg": "447b",
	"./man_made/mast_communications.svg": "a155",
	"./man_made/mast_lighting.svg": "8f02",
	"./man_made/power_tower.svg": "82f2",
	"./man_made/power_tower_small.svg": "7e4b",
	"./man_made/storage_tank.svg": "bc9e",
	"./man_made/telescope_dish.svg": "c591",
	"./man_made/telescope_dome.svg": "8f93",
	"./man_made/tower_cantilever_communication.svg": "0d1e",
	"./man_made/tower_cooling.svg": "a022",
	"./man_made/tower_defensive.svg": "2013",
	"./man_made/tower_dish.svg": "77ed",
	"./man_made/tower_dome.svg": "eabe",
	"./man_made/tower_generic.svg": "dfc6",
	"./man_made/tower_lattice.svg": "bf5e",
	"./man_made/tower_lattice_communication.svg": "7bd5",
	"./man_made/tower_lattice_lighting.svg": "c812",
	"./man_made/tower_lighting.svg": "b272",
	"./man_made/tower_observation.svg": "69de",
	"./man_made/water_tower.svg": "cc3f",
	"./man_made/windmill.svg": "a919",
	"./natural/cave.svg": "36de",
	"./natural/peak.svg": "8139",
	"./natural/saddle.svg": "1041",
	"./natural/spring.svg": "e21e",
	"./natural/waterfall.svg": "c7ee",
	"./office/consulate.svg": "7760",
	"./office/embassy.svg": "d0d4",
	"./place/place-4-z7.svg": "47ca",
	"./place/place-4.svg": "1351",
	"./place/place-6-z7.svg": "e86e",
	"./place/place-6.svg": "0477",
	"./place/place-capital-6.svg": "23d3",
	"./place/place-capital-8.svg": "9317",
	"./religion/buddhist.svg": "6207",
	"./religion/christian.svg": "3fa1",
	"./religion/hinduist.svg": "b865",
	"./religion/jewish.svg": "679d",
	"./religion/muslim.svg": "85e2",
	"./religion/shintoist.svg": "cfb7",
	"./religion/sikhist.svg": "97a2",
	"./religion/taoist.svg": "a8d9",
	"./shields/motorway_10x1.svg": "1c96",
	"./shields/motorway_10x1_z16.svg": "551d",
	"./shields/motorway_10x1_z18.svg": "75b2",
	"./shields/motorway_10x2.svg": "be5b",
	"./shields/motorway_10x2_z16.svg": "6a59",
	"./shields/motorway_10x2_z18.svg": "3399",
	"./shields/motorway_10x3.svg": "2c33",
	"./shields/motorway_10x3_z16.svg": "8e41",
	"./shields/motorway_10x3_z18.svg": "0922",
	"./shields/motorway_10x4.svg": "9953",
	"./shields/motorway_10x4_z16.svg": "2130",
	"./shields/motorway_10x4_z18.svg": "ab17",
	"./shields/motorway_11x1.svg": "6e05",
	"./shields/motorway_11x1_z16.svg": "797a",
	"./shields/motorway_11x1_z18.svg": "a0cb",
	"./shields/motorway_11x2.svg": "abe1",
	"./shields/motorway_11x2_z16.svg": "77fb",
	"./shields/motorway_11x2_z18.svg": "18bf",
	"./shields/motorway_11x3.svg": "29ed",
	"./shields/motorway_11x3_z16.svg": "7a1a",
	"./shields/motorway_11x3_z18.svg": "65c6",
	"./shields/motorway_11x4.svg": "674a",
	"./shields/motorway_11x4_z16.svg": "5ed2",
	"./shields/motorway_11x4_z18.svg": "18bf0",
	"./shields/motorway_1x1.svg": "1cb5",
	"./shields/motorway_1x1_z16.svg": "da77",
	"./shields/motorway_1x1_z18.svg": "fc85",
	"./shields/motorway_1x2.svg": "784b",
	"./shields/motorway_1x2_z16.svg": "9373",
	"./shields/motorway_1x2_z18.svg": "52cd",
	"./shields/motorway_1x3.svg": "1169",
	"./shields/motorway_1x3_z16.svg": "b0c5",
	"./shields/motorway_1x3_z18.svg": "097a",
	"./shields/motorway_1x4.svg": "3e64",
	"./shields/motorway_1x4_z16.svg": "8315",
	"./shields/motorway_1x4_z18.svg": "c8bb",
	"./shields/motorway_2x1.svg": "8c59",
	"./shields/motorway_2x1_z16.svg": "3c66",
	"./shields/motorway_2x1_z18.svg": "157d",
	"./shields/motorway_2x2.svg": "bc3e",
	"./shields/motorway_2x2_z16.svg": "e1c3",
	"./shields/motorway_2x2_z18.svg": "0b83",
	"./shields/motorway_2x3.svg": "bb02",
	"./shields/motorway_2x3_z16.svg": "4b6c",
	"./shields/motorway_2x3_z18.svg": "be38",
	"./shields/motorway_2x4.svg": "ec18d",
	"./shields/motorway_2x4_z16.svg": "25fe",
	"./shields/motorway_2x4_z18.svg": "70e0",
	"./shields/motorway_3x1.svg": "bd6c",
	"./shields/motorway_3x1_z16.svg": "68e7",
	"./shields/motorway_3x1_z18.svg": "11696",
	"./shields/motorway_3x2.svg": "50ed",
	"./shields/motorway_3x2_z16.svg": "3d66",
	"./shields/motorway_3x2_z18.svg": "d273",
	"./shields/motorway_3x3.svg": "b940",
	"./shields/motorway_3x3_z16.svg": "e059",
	"./shields/motorway_3x3_z18.svg": "28b0",
	"./shields/motorway_3x4.svg": "3830",
	"./shields/motorway_3x4_z16.svg": "311b",
	"./shields/motorway_3x4_z18.svg": "b943",
	"./shields/motorway_4x1.svg": "a435",
	"./shields/motorway_4x1_z16.svg": "750d",
	"./shields/motorway_4x1_z18.svg": "9677",
	"./shields/motorway_4x2.svg": "2a41",
	"./shields/motorway_4x2_z16.svg": "86ac",
	"./shields/motorway_4x2_z18.svg": "418e",
	"./shields/motorway_4x3.svg": "f802",
	"./shields/motorway_4x3_z16.svg": "85c1",
	"./shields/motorway_4x3_z18.svg": "604d",
	"./shields/motorway_4x4.svg": "54ae",
	"./shields/motorway_4x4_z16.svg": "13bc",
	"./shields/motorway_4x4_z18.svg": "51be",
	"./shields/motorway_5x1.svg": "43a7",
	"./shields/motorway_5x1_z16.svg": "74f8",
	"./shields/motorway_5x1_z18.svg": "adc4",
	"./shields/motorway_5x2.svg": "d7c5",
	"./shields/motorway_5x2_z16.svg": "266a",
	"./shields/motorway_5x2_z18.svg": "5665",
	"./shields/motorway_5x3.svg": "d19e",
	"./shields/motorway_5x3_z16.svg": "275b",
	"./shields/motorway_5x3_z18.svg": "ad34",
	"./shields/motorway_5x4.svg": "d3db",
	"./shields/motorway_5x4_z16.svg": "1823",
	"./shields/motorway_5x4_z18.svg": "74e8",
	"./shields/motorway_6x1.svg": "e6bf",
	"./shields/motorway_6x1_z16.svg": "27b6",
	"./shields/motorway_6x1_z18.svg": "860b",
	"./shields/motorway_6x2.svg": "6d26",
	"./shields/motorway_6x2_z16.svg": "cf47",
	"./shields/motorway_6x2_z18.svg": "5bbd",
	"./shields/motorway_6x3.svg": "d5b3",
	"./shields/motorway_6x3_z16.svg": "f3f4",
	"./shields/motorway_6x3_z18.svg": "2ea3",
	"./shields/motorway_6x4.svg": "05ce",
	"./shields/motorway_6x4_z16.svg": "80b2",
	"./shields/motorway_6x4_z18.svg": "a7b3",
	"./shields/motorway_7x1.svg": "e3b8",
	"./shields/motorway_7x1_z16.svg": "71f3",
	"./shields/motorway_7x1_z18.svg": "4c75",
	"./shields/motorway_7x2.svg": "05f8",
	"./shields/motorway_7x2_z16.svg": "84d1",
	"./shields/motorway_7x2_z18.svg": "2175",
	"./shields/motorway_7x3.svg": "725e",
	"./shields/motorway_7x3_z16.svg": "26c1",
	"./shields/motorway_7x3_z18.svg": "0be8",
	"./shields/motorway_7x4.svg": "0d5f",
	"./shields/motorway_7x4_z16.svg": "1fb7",
	"./shields/motorway_7x4_z18.svg": "81c8",
	"./shields/motorway_8x1.svg": "af5b",
	"./shields/motorway_8x1_z16.svg": "5ebc",
	"./shields/motorway_8x1_z18.svg": "aea0",
	"./shields/motorway_8x2.svg": "847d",
	"./shields/motorway_8x2_z16.svg": "1de4",
	"./shields/motorway_8x2_z18.svg": "3da8",
	"./shields/motorway_8x3.svg": "700a",
	"./shields/motorway_8x3_z16.svg": "2a2c",
	"./shields/motorway_8x3_z18.svg": "cd99",
	"./shields/motorway_8x4.svg": "c979",
	"./shields/motorway_8x4_z16.svg": "52b4",
	"./shields/motorway_8x4_z18.svg": "a014",
	"./shields/motorway_9x1.svg": "fca0",
	"./shields/motorway_9x1_z16.svg": "c8cf",
	"./shields/motorway_9x1_z18.svg": "230b",
	"./shields/motorway_9x2.svg": "8cb8",
	"./shields/motorway_9x2_z16.svg": "242f",
	"./shields/motorway_9x2_z18.svg": "0143",
	"./shields/motorway_9x3.svg": "1b4f",
	"./shields/motorway_9x3_z16.svg": "640f",
	"./shields/motorway_9x3_z18.svg": "25ba",
	"./shields/motorway_9x4.svg": "a8f4",
	"./shields/motorway_9x4_z16.svg": "7926",
	"./shields/motorway_9x4_z18.svg": "14cd",
	"./shields/primary_10x1.svg": "ebbd",
	"./shields/primary_10x1_z16.svg": "f989",
	"./shields/primary_10x1_z18.svg": "2061",
	"./shields/primary_10x2.svg": "3e70",
	"./shields/primary_10x2_z16.svg": "e26f",
	"./shields/primary_10x2_z18.svg": "8993",
	"./shields/primary_10x3.svg": "0857",
	"./shields/primary_10x3_z16.svg": "5f98",
	"./shields/primary_10x3_z18.svg": "db8b",
	"./shields/primary_10x4.svg": "5f67",
	"./shields/primary_10x4_z16.svg": "ef23",
	"./shields/primary_10x4_z18.svg": "a512",
	"./shields/primary_11x1.svg": "0a22",
	"./shields/primary_11x1_z16.svg": "59d9",
	"./shields/primary_11x1_z18.svg": "50f1",
	"./shields/primary_11x2.svg": "b048",
	"./shields/primary_11x2_z16.svg": "c1e3",
	"./shields/primary_11x2_z18.svg": "2b5a",
	"./shields/primary_11x3.svg": "98fd",
	"./shields/primary_11x3_z16.svg": "93dd",
	"./shields/primary_11x3_z18.svg": "9737",
	"./shields/primary_11x4.svg": "d689",
	"./shields/primary_11x4_z16.svg": "fc42",
	"./shields/primary_11x4_z18.svg": "5d03",
	"./shields/primary_1x1.svg": "493d",
	"./shields/primary_1x1_z16.svg": "0c5a",
	"./shields/primary_1x1_z18.svg": "c594",
	"./shields/primary_1x2.svg": "0c63",
	"./shields/primary_1x2_z16.svg": "439f",
	"./shields/primary_1x2_z18.svg": "0f81",
	"./shields/primary_1x3.svg": "e25b",
	"./shields/primary_1x3_z16.svg": "b175",
	"./shields/primary_1x3_z18.svg": "4e22",
	"./shields/primary_1x4.svg": "62cd",
	"./shields/primary_1x4_z16.svg": "7294",
	"./shields/primary_1x4_z18.svg": "2450",
	"./shields/primary_2x1.svg": "8078",
	"./shields/primary_2x1_z16.svg": "ee12",
	"./shields/primary_2x1_z18.svg": "c340",
	"./shields/primary_2x2.svg": "96c8",
	"./shields/primary_2x2_z16.svg": "74a2",
	"./shields/primary_2x2_z18.svg": "5bda",
	"./shields/primary_2x3.svg": "13c3",
	"./shields/primary_2x3_z16.svg": "fa78",
	"./shields/primary_2x3_z18.svg": "0869",
	"./shields/primary_2x4.svg": "1826",
	"./shields/primary_2x4_z16.svg": "ea4a",
	"./shields/primary_2x4_z18.svg": "beac",
	"./shields/primary_3x1.svg": "b013",
	"./shields/primary_3x1_z16.svg": "ca6e",
	"./shields/primary_3x1_z18.svg": "7419",
	"./shields/primary_3x2.svg": "9d3d",
	"./shields/primary_3x2_z16.svg": "218e",
	"./shields/primary_3x2_z18.svg": "b799",
	"./shields/primary_3x3.svg": "1aee",
	"./shields/primary_3x3_z16.svg": "be3b",
	"./shields/primary_3x3_z18.svg": "296a",
	"./shields/primary_3x4.svg": "f912",
	"./shields/primary_3x4_z16.svg": "55f0",
	"./shields/primary_3x4_z18.svg": "ed47",
	"./shields/primary_4x1.svg": "5649",
	"./shields/primary_4x1_z16.svg": "2d69",
	"./shields/primary_4x1_z18.svg": "5182",
	"./shields/primary_4x2.svg": "3bc3",
	"./shields/primary_4x2_z16.svg": "adc7",
	"./shields/primary_4x2_z18.svg": "76f6",
	"./shields/primary_4x3.svg": "3d8b",
	"./shields/primary_4x3_z16.svg": "6f31",
	"./shields/primary_4x3_z18.svg": "e7b5",
	"./shields/primary_4x4.svg": "2959",
	"./shields/primary_4x4_z16.svg": "efab",
	"./shields/primary_4x4_z18.svg": "6432",
	"./shields/primary_5x1.svg": "ea08",
	"./shields/primary_5x1_z16.svg": "aefc",
	"./shields/primary_5x1_z18.svg": "1f05",
	"./shields/primary_5x2.svg": "8122",
	"./shields/primary_5x2_z16.svg": "8b98",
	"./shields/primary_5x2_z18.svg": "184d",
	"./shields/primary_5x3.svg": "0159",
	"./shields/primary_5x3_z16.svg": "0707",
	"./shields/primary_5x3_z18.svg": "1018",
	"./shields/primary_5x4.svg": "c1c5",
	"./shields/primary_5x4_z16.svg": "cd96",
	"./shields/primary_5x4_z18.svg": "8fa7",
	"./shields/primary_6x1.svg": "fe0e",
	"./shields/primary_6x1_z16.svg": "cbf9",
	"./shields/primary_6x1_z18.svg": "381d",
	"./shields/primary_6x2.svg": "98ef",
	"./shields/primary_6x2_z16.svg": "ec6f",
	"./shields/primary_6x2_z18.svg": "09d4",
	"./shields/primary_6x3.svg": "1b95",
	"./shields/primary_6x3_z16.svg": "7ddf",
	"./shields/primary_6x3_z18.svg": "6c8d",
	"./shields/primary_6x4.svg": "5742",
	"./shields/primary_6x4_z16.svg": "cd0b",
	"./shields/primary_6x4_z18.svg": "3626",
	"./shields/primary_7x1.svg": "7639",
	"./shields/primary_7x1_z16.svg": "9827",
	"./shields/primary_7x1_z18.svg": "79f9",
	"./shields/primary_7x2.svg": "2d2c",
	"./shields/primary_7x2_z16.svg": "85fea",
	"./shields/primary_7x2_z18.svg": "8764",
	"./shields/primary_7x3.svg": "4197",
	"./shields/primary_7x3_z16.svg": "2867",
	"./shields/primary_7x3_z18.svg": "9f82",
	"./shields/primary_7x4.svg": "cfba",
	"./shields/primary_7x4_z16.svg": "d547",
	"./shields/primary_7x4_z18.svg": "2dee",
	"./shields/primary_8x1.svg": "a50e",
	"./shields/primary_8x1_z16.svg": "dc75",
	"./shields/primary_8x1_z18.svg": "4c5b",
	"./shields/primary_8x2.svg": "1571",
	"./shields/primary_8x2_z16.svg": "e9b6",
	"./shields/primary_8x2_z18.svg": "3cb1",
	"./shields/primary_8x3.svg": "219d",
	"./shields/primary_8x3_z16.svg": "e1d8",
	"./shields/primary_8x3_z18.svg": "edd2",
	"./shields/primary_8x4.svg": "d299",
	"./shields/primary_8x4_z16.svg": "2ed4",
	"./shields/primary_8x4_z18.svg": "7033",
	"./shields/primary_9x1.svg": "2d12",
	"./shields/primary_9x1_z16.svg": "6360",
	"./shields/primary_9x1_z18.svg": "5418",
	"./shields/primary_9x2.svg": "faa0",
	"./shields/primary_9x2_z16.svg": "5c24",
	"./shields/primary_9x2_z18.svg": "503b",
	"./shields/primary_9x3.svg": "cdde",
	"./shields/primary_9x3_z16.svg": "6fd2",
	"./shields/primary_9x3_z18.svg": "462a",
	"./shields/primary_9x4.svg": "6c8b",
	"./shields/primary_9x4_z16.svg": "ec75",
	"./shields/primary_9x4_z18.svg": "561a",
	"./shields/secondary_10x1.svg": "9dae",
	"./shields/secondary_10x1_z16.svg": "1b8a",
	"./shields/secondary_10x1_z18.svg": "5599",
	"./shields/secondary_10x2.svg": "f790",
	"./shields/secondary_10x2_z16.svg": "b17f",
	"./shields/secondary_10x2_z18.svg": "107c",
	"./shields/secondary_10x3.svg": "584c",
	"./shields/secondary_10x3_z16.svg": "2042",
	"./shields/secondary_10x3_z18.svg": "db47",
	"./shields/secondary_10x4.svg": "55e0",
	"./shields/secondary_10x4_z16.svg": "dca6",
	"./shields/secondary_10x4_z18.svg": "8757",
	"./shields/secondary_11x1.svg": "c54c",
	"./shields/secondary_11x1_z16.svg": "39d8",
	"./shields/secondary_11x1_z18.svg": "a7a3",
	"./shields/secondary_11x2.svg": "3cf9",
	"./shields/secondary_11x2_z16.svg": "c925",
	"./shields/secondary_11x2_z18.svg": "7c25",
	"./shields/secondary_11x3.svg": "a04c",
	"./shields/secondary_11x3_z16.svg": "00cb",
	"./shields/secondary_11x3_z18.svg": "0fa4",
	"./shields/secondary_11x4.svg": "1249",
	"./shields/secondary_11x4_z16.svg": "8af9",
	"./shields/secondary_11x4_z18.svg": "e773",
	"./shields/secondary_1x1.svg": "25c1",
	"./shields/secondary_1x1_z16.svg": "44cc",
	"./shields/secondary_1x1_z18.svg": "ee15",
	"./shields/secondary_1x2.svg": "3513",
	"./shields/secondary_1x2_z16.svg": "8eea",
	"./shields/secondary_1x2_z18.svg": "609c",
	"./shields/secondary_1x3.svg": "72db",
	"./shields/secondary_1x3_z16.svg": "fbf0",
	"./shields/secondary_1x3_z18.svg": "53ad",
	"./shields/secondary_1x4.svg": "1039",
	"./shields/secondary_1x4_z16.svg": "7766",
	"./shields/secondary_1x4_z18.svg": "1034",
	"./shields/secondary_2x1.svg": "153f",
	"./shields/secondary_2x1_z16.svg": "a209",
	"./shields/secondary_2x1_z18.svg": "86f3",
	"./shields/secondary_2x2.svg": "356f",
	"./shields/secondary_2x2_z16.svg": "1372",
	"./shields/secondary_2x2_z18.svg": "8f67",
	"./shields/secondary_2x3.svg": "1ca3",
	"./shields/secondary_2x3_z16.svg": "00b5",
	"./shields/secondary_2x3_z18.svg": "a859",
	"./shields/secondary_2x4.svg": "d6d5",
	"./shields/secondary_2x4_z16.svg": "5019",
	"./shields/secondary_2x4_z18.svg": "1ab6",
	"./shields/secondary_3x1.svg": "e1c5",
	"./shields/secondary_3x1_z16.svg": "89eb",
	"./shields/secondary_3x1_z18.svg": "7813",
	"./shields/secondary_3x2.svg": "4821",
	"./shields/secondary_3x2_z16.svg": "7399",
	"./shields/secondary_3x2_z18.svg": "fc58",
	"./shields/secondary_3x3.svg": "603f",
	"./shields/secondary_3x3_z16.svg": "1b11",
	"./shields/secondary_3x3_z18.svg": "cfcb",
	"./shields/secondary_3x4.svg": "a76c",
	"./shields/secondary_3x4_z16.svg": "6fd5",
	"./shields/secondary_3x4_z18.svg": "5850",
	"./shields/secondary_4x1.svg": "79e1",
	"./shields/secondary_4x1_z16.svg": "37d6",
	"./shields/secondary_4x1_z18.svg": "26be",
	"./shields/secondary_4x2.svg": "bd54",
	"./shields/secondary_4x2_z16.svg": "2cdd",
	"./shields/secondary_4x2_z18.svg": "7ec1",
	"./shields/secondary_4x3.svg": "1dbb",
	"./shields/secondary_4x3_z16.svg": "7160",
	"./shields/secondary_4x3_z18.svg": "2e7b",
	"./shields/secondary_4x4.svg": "e78a",
	"./shields/secondary_4x4_z16.svg": "344b",
	"./shields/secondary_4x4_z18.svg": "8b77",
	"./shields/secondary_5x1.svg": "cf3e",
	"./shields/secondary_5x1_z16.svg": "fb39",
	"./shields/secondary_5x1_z18.svg": "68c3",
	"./shields/secondary_5x2.svg": "e67b",
	"./shields/secondary_5x2_z16.svg": "ebb3",
	"./shields/secondary_5x2_z18.svg": "da77d",
	"./shields/secondary_5x3.svg": "9db1",
	"./shields/secondary_5x3_z16.svg": "4754a",
	"./shields/secondary_5x3_z18.svg": "4b38",
	"./shields/secondary_5x4.svg": "9cc2",
	"./shields/secondary_5x4_z16.svg": "a3f7",
	"./shields/secondary_5x4_z18.svg": "9ace",
	"./shields/secondary_6x1.svg": "92b0",
	"./shields/secondary_6x1_z16.svg": "fbce",
	"./shields/secondary_6x1_z18.svg": "f4e5",
	"./shields/secondary_6x2.svg": "c1a5",
	"./shields/secondary_6x2_z16.svg": "181e",
	"./shields/secondary_6x2_z18.svg": "62f3",
	"./shields/secondary_6x3.svg": "9433",
	"./shields/secondary_6x3_z16.svg": "6da2",
	"./shields/secondary_6x3_z18.svg": "5691",
	"./shields/secondary_6x4.svg": "da1a",
	"./shields/secondary_6x4_z16.svg": "5349",
	"./shields/secondary_6x4_z18.svg": "bffb",
	"./shields/secondary_7x1.svg": "98dd",
	"./shields/secondary_7x1_z16.svg": "432a",
	"./shields/secondary_7x1_z18.svg": "a36e",
	"./shields/secondary_7x2.svg": "7f1e",
	"./shields/secondary_7x2_z16.svg": "8df6",
	"./shields/secondary_7x2_z18.svg": "5fd1",
	"./shields/secondary_7x3.svg": "f7b7",
	"./shields/secondary_7x3_z16.svg": "2988",
	"./shields/secondary_7x3_z18.svg": "d60a",
	"./shields/secondary_7x4.svg": "3f19",
	"./shields/secondary_7x4_z16.svg": "dd1d",
	"./shields/secondary_7x4_z18.svg": "6ec1",
	"./shields/secondary_8x1.svg": "645f",
	"./shields/secondary_8x1_z16.svg": "9a79",
	"./shields/secondary_8x1_z18.svg": "a08b",
	"./shields/secondary_8x2.svg": "c726",
	"./shields/secondary_8x2_z16.svg": "ebf4",
	"./shields/secondary_8x2_z18.svg": "97a1",
	"./shields/secondary_8x3.svg": "db70",
	"./shields/secondary_8x3_z16.svg": "5e6d",
	"./shields/secondary_8x3_z18.svg": "5d61",
	"./shields/secondary_8x4.svg": "9814",
	"./shields/secondary_8x4_z16.svg": "dbeb",
	"./shields/secondary_8x4_z18.svg": "441a",
	"./shields/secondary_9x1.svg": "7681",
	"./shields/secondary_9x1_z16.svg": "b2b9",
	"./shields/secondary_9x1_z18.svg": "d731",
	"./shields/secondary_9x2.svg": "52f1",
	"./shields/secondary_9x2_z16.svg": "aef8",
	"./shields/secondary_9x2_z18.svg": "fae7",
	"./shields/secondary_9x3.svg": "a319",
	"./shields/secondary_9x3_z16.svg": "fc87",
	"./shields/secondary_9x3_z18.svg": "385b",
	"./shields/secondary_9x4.svg": "67a7",
	"./shields/secondary_9x4_z16.svg": "3839",
	"./shields/secondary_9x4_z18.svg": "f0e4",
	"./shields/tertiary_10x1.svg": "3c7f",
	"./shields/tertiary_10x1_z16.svg": "fd32",
	"./shields/tertiary_10x1_z18.svg": "50d2",
	"./shields/tertiary_10x2.svg": "6b8b",
	"./shields/tertiary_10x2_z16.svg": "2614",
	"./shields/tertiary_10x2_z18.svg": "dd33",
	"./shields/tertiary_10x3.svg": "81ab",
	"./shields/tertiary_10x3_z16.svg": "d430",
	"./shields/tertiary_10x3_z18.svg": "91a6",
	"./shields/tertiary_10x4.svg": "edee",
	"./shields/tertiary_10x4_z16.svg": "fe8b",
	"./shields/tertiary_10x4_z18.svg": "7198",
	"./shields/tertiary_11x1.svg": "50db",
	"./shields/tertiary_11x1_z16.svg": "4596",
	"./shields/tertiary_11x1_z18.svg": "570c",
	"./shields/tertiary_11x2.svg": "cee3",
	"./shields/tertiary_11x2_z16.svg": "2a99",
	"./shields/tertiary_11x2_z18.svg": "6d20",
	"./shields/tertiary_11x3.svg": "64ba",
	"./shields/tertiary_11x3_z16.svg": "a235",
	"./shields/tertiary_11x3_z18.svg": "d203",
	"./shields/tertiary_11x4.svg": "a6c1",
	"./shields/tertiary_11x4_z16.svg": "28af",
	"./shields/tertiary_11x4_z18.svg": "3031",
	"./shields/tertiary_1x1.svg": "7498",
	"./shields/tertiary_1x1_z16.svg": "27a2",
	"./shields/tertiary_1x1_z18.svg": "5ff5",
	"./shields/tertiary_1x2.svg": "f560",
	"./shields/tertiary_1x2_z16.svg": "f09f",
	"./shields/tertiary_1x2_z18.svg": "5d16",
	"./shields/tertiary_1x3.svg": "a584",
	"./shields/tertiary_1x3_z16.svg": "f61f",
	"./shields/tertiary_1x3_z18.svg": "873d",
	"./shields/tertiary_1x4.svg": "886a",
	"./shields/tertiary_1x4_z16.svg": "59f1",
	"./shields/tertiary_1x4_z18.svg": "28a3",
	"./shields/tertiary_2x1.svg": "d19d",
	"./shields/tertiary_2x1_z16.svg": "0666",
	"./shields/tertiary_2x1_z18.svg": "362e",
	"./shields/tertiary_2x2.svg": "ac9f",
	"./shields/tertiary_2x2_z16.svg": "9096",
	"./shields/tertiary_2x2_z18.svg": "eca4",
	"./shields/tertiary_2x3.svg": "690d",
	"./shields/tertiary_2x3_z16.svg": "7603",
	"./shields/tertiary_2x3_z18.svg": "5dca",
	"./shields/tertiary_2x4.svg": "7a61",
	"./shields/tertiary_2x4_z16.svg": "2484",
	"./shields/tertiary_2x4_z18.svg": "bba5",
	"./shields/tertiary_3x1.svg": "bee8",
	"./shields/tertiary_3x1_z16.svg": "6706",
	"./shields/tertiary_3x1_z18.svg": "38dc",
	"./shields/tertiary_3x2.svg": "ff75",
	"./shields/tertiary_3x2_z16.svg": "f04d",
	"./shields/tertiary_3x2_z18.svg": "a2f1",
	"./shields/tertiary_3x3.svg": "1d68",
	"./shields/tertiary_3x3_z16.svg": "3025",
	"./shields/tertiary_3x3_z18.svg": "08e1",
	"./shields/tertiary_3x4.svg": "2de4a",
	"./shields/tertiary_3x4_z16.svg": "6791",
	"./shields/tertiary_3x4_z18.svg": "2ccd",
	"./shields/tertiary_4x1.svg": "e1a6",
	"./shields/tertiary_4x1_z16.svg": "dcc8",
	"./shields/tertiary_4x1_z18.svg": "0819",
	"./shields/tertiary_4x2.svg": "9416",
	"./shields/tertiary_4x2_z16.svg": "618c",
	"./shields/tertiary_4x2_z18.svg": "261e",
	"./shields/tertiary_4x3.svg": "dfe7",
	"./shields/tertiary_4x3_z16.svg": "c0c9",
	"./shields/tertiary_4x3_z18.svg": "406c",
	"./shields/tertiary_4x4.svg": "6977",
	"./shields/tertiary_4x4_z16.svg": "7f9e",
	"./shields/tertiary_4x4_z18.svg": "68b8",
	"./shields/tertiary_5x1.svg": "eb09",
	"./shields/tertiary_5x1_z16.svg": "3c88",
	"./shields/tertiary_5x1_z18.svg": "d404",
	"./shields/tertiary_5x2.svg": "0ea0",
	"./shields/tertiary_5x2_z16.svg": "6bb0",
	"./shields/tertiary_5x2_z18.svg": "1c70",
	"./shields/tertiary_5x3.svg": "e693",
	"./shields/tertiary_5x3_z16.svg": "7a35",
	"./shields/tertiary_5x3_z18.svg": "a176",
	"./shields/tertiary_5x4.svg": "47a7",
	"./shields/tertiary_5x4_z16.svg": "2ed7",
	"./shields/tertiary_5x4_z18.svg": "7a7f",
	"./shields/tertiary_6x1.svg": "e65c",
	"./shields/tertiary_6x1_z16.svg": "7592",
	"./shields/tertiary_6x1_z18.svg": "b814",
	"./shields/tertiary_6x2.svg": "de43",
	"./shields/tertiary_6x2_z16.svg": "ba4e",
	"./shields/tertiary_6x2_z18.svg": "49c7",
	"./shields/tertiary_6x3.svg": "fc4b",
	"./shields/tertiary_6x3_z16.svg": "446e",
	"./shields/tertiary_6x3_z18.svg": "ea09",
	"./shields/tertiary_6x4.svg": "cb75",
	"./shields/tertiary_6x4_z16.svg": "63c9",
	"./shields/tertiary_6x4_z18.svg": "a847",
	"./shields/tertiary_7x1.svg": "9d12",
	"./shields/tertiary_7x1_z16.svg": "d7f1",
	"./shields/tertiary_7x1_z18.svg": "ec12",
	"./shields/tertiary_7x2.svg": "692a",
	"./shields/tertiary_7x2_z16.svg": "bfcf",
	"./shields/tertiary_7x2_z18.svg": "9a62",
	"./shields/tertiary_7x3.svg": "b658",
	"./shields/tertiary_7x3_z16.svg": "4544",
	"./shields/tertiary_7x3_z18.svg": "cf8c",
	"./shields/tertiary_7x4.svg": "c2ae",
	"./shields/tertiary_7x4_z16.svg": "a731",
	"./shields/tertiary_7x4_z18.svg": "c979b",
	"./shields/tertiary_8x1.svg": "f664",
	"./shields/tertiary_8x1_z16.svg": "ef2a",
	"./shields/tertiary_8x1_z18.svg": "8403",
	"./shields/tertiary_8x2.svg": "3fba",
	"./shields/tertiary_8x2_z16.svg": "efe1",
	"./shields/tertiary_8x2_z18.svg": "51c9",
	"./shields/tertiary_8x3.svg": "b69b",
	"./shields/tertiary_8x3_z16.svg": "a6b4",
	"./shields/tertiary_8x3_z18.svg": "720b",
	"./shields/tertiary_8x4.svg": "1354",
	"./shields/tertiary_8x4_z16.svg": "677c",
	"./shields/tertiary_8x4_z18.svg": "0053",
	"./shields/tertiary_9x1.svg": "87f6",
	"./shields/tertiary_9x1_z16.svg": "0f1f",
	"./shields/tertiary_9x1_z18.svg": "afd1",
	"./shields/tertiary_9x2.svg": "9193",
	"./shields/tertiary_9x2_z16.svg": "46a3",
	"./shields/tertiary_9x2_z18.svg": "860b2",
	"./shields/tertiary_9x3.svg": "3182",
	"./shields/tertiary_9x3_z16.svg": "48df",
	"./shields/tertiary_9x3_z18.svg": "b69d",
	"./shields/tertiary_9x4.svg": "6c8f",
	"./shields/tertiary_9x4_z16.svg": "c5cb",
	"./shields/tertiary_9x4_z18.svg": "8215",
	"./shields/trunk_10x1.svg": "569a",
	"./shields/trunk_10x1_z16.svg": "a244",
	"./shields/trunk_10x1_z18.svg": "fe31",
	"./shields/trunk_10x2.svg": "79b7",
	"./shields/trunk_10x2_z16.svg": "f283",
	"./shields/trunk_10x2_z18.svg": "e6f2",
	"./shields/trunk_10x3.svg": "9126",
	"./shields/trunk_10x3_z16.svg": "b269",
	"./shields/trunk_10x3_z18.svg": "e0c9",
	"./shields/trunk_10x4.svg": "9a1a",
	"./shields/trunk_10x4_z16.svg": "b587",
	"./shields/trunk_10x4_z18.svg": "79b0",
	"./shields/trunk_11x1.svg": "cbc8",
	"./shields/trunk_11x1_z16.svg": "e7e2",
	"./shields/trunk_11x1_z18.svg": "08f4",
	"./shields/trunk_11x2.svg": "e11f",
	"./shields/trunk_11x2_z16.svg": "418a",
	"./shields/trunk_11x2_z18.svg": "6af8",
	"./shields/trunk_11x3.svg": "f3bd",
	"./shields/trunk_11x3_z16.svg": "579b",
	"./shields/trunk_11x3_z18.svg": "d9d2",
	"./shields/trunk_11x4.svg": "a508",
	"./shields/trunk_11x4_z16.svg": "ce10",
	"./shields/trunk_11x4_z18.svg": "bedf",
	"./shields/trunk_1x1.svg": "543e",
	"./shields/trunk_1x1_z16.svg": "5783",
	"./shields/trunk_1x1_z18.svg": "6d7e",
	"./shields/trunk_1x2.svg": "4439",
	"./shields/trunk_1x2_z16.svg": "ffcf",
	"./shields/trunk_1x2_z18.svg": "d5ff",
	"./shields/trunk_1x3.svg": "5f62",
	"./shields/trunk_1x3_z16.svg": "4bb6",
	"./shields/trunk_1x3_z18.svg": "4d93",
	"./shields/trunk_1x4.svg": "9db4",
	"./shields/trunk_1x4_z16.svg": "a449",
	"./shields/trunk_1x4_z18.svg": "87b9",
	"./shields/trunk_2x1.svg": "916a",
	"./shields/trunk_2x1_z16.svg": "b185",
	"./shields/trunk_2x1_z18.svg": "773d",
	"./shields/trunk_2x2.svg": "81e5",
	"./shields/trunk_2x2_z16.svg": "2d06",
	"./shields/trunk_2x2_z18.svg": "309b",
	"./shields/trunk_2x3.svg": "e749",
	"./shields/trunk_2x3_z16.svg": "3a14",
	"./shields/trunk_2x3_z18.svg": "24cb",
	"./shields/trunk_2x4.svg": "22bf",
	"./shields/trunk_2x4_z16.svg": "0c9b",
	"./shields/trunk_2x4_z18.svg": "5a1c",
	"./shields/trunk_3x1.svg": "4e2a",
	"./shields/trunk_3x1_z16.svg": "3a79",
	"./shields/trunk_3x1_z18.svg": "54cc",
	"./shields/trunk_3x2.svg": "66a9",
	"./shields/trunk_3x2_z16.svg": "3af1",
	"./shields/trunk_3x2_z18.svg": "3a7e",
	"./shields/trunk_3x3.svg": "fb70",
	"./shields/trunk_3x3_z16.svg": "53db",
	"./shields/trunk_3x3_z18.svg": "690a",
	"./shields/trunk_3x4.svg": "b649",
	"./shields/trunk_3x4_z16.svg": "9650",
	"./shields/trunk_3x4_z18.svg": "09f7",
	"./shields/trunk_4x1.svg": "2719",
	"./shields/trunk_4x1_z16.svg": "6bbf",
	"./shields/trunk_4x1_z18.svg": "c565",
	"./shields/trunk_4x2.svg": "603b",
	"./shields/trunk_4x2_z16.svg": "af93",
	"./shields/trunk_4x2_z18.svg": "0952",
	"./shields/trunk_4x3.svg": "7622",
	"./shields/trunk_4x3_z16.svg": "9698",
	"./shields/trunk_4x3_z18.svg": "17f2",
	"./shields/trunk_4x4.svg": "3eed",
	"./shields/trunk_4x4_z16.svg": "722a",
	"./shields/trunk_4x4_z18.svg": "1ecc",
	"./shields/trunk_5x1.svg": "7e53",
	"./shields/trunk_5x1_z16.svg": "b113",
	"./shields/trunk_5x1_z18.svg": "ad78",
	"./shields/trunk_5x2.svg": "18a2",
	"./shields/trunk_5x2_z16.svg": "47bc",
	"./shields/trunk_5x2_z18.svg": "e6f0",
	"./shields/trunk_5x3.svg": "df78",
	"./shields/trunk_5x3_z16.svg": "8e43",
	"./shields/trunk_5x3_z18.svg": "1e93",
	"./shields/trunk_5x4.svg": "ebeb",
	"./shields/trunk_5x4_z16.svg": "fd47",
	"./shields/trunk_5x4_z18.svg": "dcbb",
	"./shields/trunk_6x1.svg": "bd2f",
	"./shields/trunk_6x1_z16.svg": "7f458",
	"./shields/trunk_6x1_z18.svg": "80e8",
	"./shields/trunk_6x2.svg": "29e1",
	"./shields/trunk_6x2_z16.svg": "024a",
	"./shields/trunk_6x2_z18.svg": "01d3",
	"./shields/trunk_6x3.svg": "7d70",
	"./shields/trunk_6x3_z16.svg": "6a27",
	"./shields/trunk_6x3_z18.svg": "38b3",
	"./shields/trunk_6x4.svg": "69e6",
	"./shields/trunk_6x4_z16.svg": "a969",
	"./shields/trunk_6x4_z18.svg": "e46b",
	"./shields/trunk_7x1.svg": "6b50",
	"./shields/trunk_7x1_z16.svg": "54e5",
	"./shields/trunk_7x1_z18.svg": "0bbd",
	"./shields/trunk_7x2.svg": "8cb5",
	"./shields/trunk_7x2_z16.svg": "f3db",
	"./shields/trunk_7x2_z18.svg": "516e",
	"./shields/trunk_7x3.svg": "711b",
	"./shields/trunk_7x3_z16.svg": "6985",
	"./shields/trunk_7x3_z18.svg": "36e4",
	"./shields/trunk_7x4.svg": "f7720",
	"./shields/trunk_7x4_z16.svg": "8a9b",
	"./shields/trunk_7x4_z18.svg": "3a666",
	"./shields/trunk_8x1.svg": "1d69",
	"./shields/trunk_8x1_z16.svg": "7364",
	"./shields/trunk_8x1_z18.svg": "618e",
	"./shields/trunk_8x2.svg": "e7d3",
	"./shields/trunk_8x2_z16.svg": "2361",
	"./shields/trunk_8x2_z18.svg": "c4d2",
	"./shields/trunk_8x3.svg": "230a",
	"./shields/trunk_8x3_z16.svg": "4b95",
	"./shields/trunk_8x3_z18.svg": "5bff",
	"./shields/trunk_8x4.svg": "d2f7",
	"./shields/trunk_8x4_z16.svg": "22eb",
	"./shields/trunk_8x4_z18.svg": "f848",
	"./shields/trunk_9x1.svg": "cb47",
	"./shields/trunk_9x1_z16.svg": "bed4",
	"./shields/trunk_9x1_z18.svg": "ea21",
	"./shields/trunk_9x2.svg": "a4d1",
	"./shields/trunk_9x2_z16.svg": "060b",
	"./shields/trunk_9x2_z18.svg": "012c",
	"./shields/trunk_9x3.svg": "bec3",
	"./shields/trunk_9x3_z16.svg": "1805",
	"./shields/trunk_9x3_z18.svg": "cb3c",
	"./shields/trunk_9x4.svg": "8de2",
	"./shields/trunk_9x4_z16.svg": "1ab3",
	"./shields/trunk_9x4_z18.svg": "32ec",
	"./shop/alcohol.svg": "4b5b",
	"./shop/art.svg": "d005",
	"./shop/bag.svg": "3971",
	"./shop/bakery.svg": "6e3a",
	"./shop/beauty.svg": "9c80",
	"./shop/bed.svg": "3889",
	"./shop/beverages.svg": "0cf0",
	"./shop/bicycle.svg": "38b0",
	"./shop/bookmaker.svg": "7617",
	"./shop/butcher.svg": "5223",
	"./shop/car.svg": "7395",
	"./shop/car_parts.svg": "76c0",
	"./shop/car_repair.svg": "9520",
	"./shop/carpet.svg": "035e",
	"./shop/charity.svg": "ea3b",
	"./shop/chemist.svg": "5917",
	"./shop/clothes.svg": "cd7d",
	"./shop/coffee.svg": "3f52",
	"./shop/computer.svg": "5543",
	"./shop/confectionery.svg": "bf37",
	"./shop/convenience.svg": "0747",
	"./shop/copyshop.svg": "8d33",
	"./shop/dairy.svg": "e5ce",
	"./shop/deli.svg": "9f21",
	"./shop/department_store.svg": "5fca",
	"./shop/diy.svg": "f857",
	"./shop/electronics.svg": "85f3",
	"./shop/fabric.svg": "12d9",
	"./shop/florist.svg": "395f",
	"./shop/furniture.svg": "acf8",
	"./shop/garden_centre.svg": "0b0e",
	"./shop/gift.svg": "0694",
	"./shop/greengrocer.svg": "412a",
	"./shop/hairdresser.svg": "22db",
	"./shop/hifi.svg": "3775",
	"./shop/houseware.svg": "2d7e",
	"./shop/interior_decoration.svg": "e4bc",
	"./shop/jewelry.svg": "e619",
	"./shop/laundry.svg": "c86f",
	"./shop/marketplace.svg": "5c52",
	"./shop/massage.svg": "1866",
	"./shop/medical_supply.svg": "6209",
	"./shop/mobile_phone.svg": "c32f",
	"./shop/motorcycle.svg": "dc49",
	"./shop/music.svg": "a837",
	"./shop/musical_instrument.svg": "fb16",
	"./shop/newsagent.svg": "63af",
	"./shop/optician.svg": "05da",
	"./shop/outdoor.svg": "599f",
	"./shop/paint.svg": "f21d",
	"./shop/perfumery.svg": "7daf",
	"./shop/pet.svg": "4849",
	"./shop/photo.svg": "5d47",
	"./shop/seafood.svg": "3663",
	"./shop/second_hand.svg": "6633",
	"./shop/shoes.svg": "74f8f",
	"./shop/sports.svg": "110a",
	"./shop/stationery.svg": "b7f9",
	"./shop/supermarket.svg": "c2d0",
	"./shop/tea.svg": "5b1d",
	"./shop/ticket.svg": "60bd",
	"./shop/tobacco.svg": "6d1f",
	"./shop/toys.svg": "3275",
	"./shop/trade.svg": "32c5",
	"./shop/travel_agency.svg": "7d53",
	"./shop/tyres.svg": "b21c",
	"./shop/variety_store.svg": "a539",
	"./shop/video.svg": "15df",
	"./shop/video_games.svg": "2c70",
	"./tourism/alpinehut.svg": "0a83",
	"./tourism/apartment.svg": "fd5b",
	"./tourism/artwork.svg": "07476",
	"./tourism/audioguide.svg": "d4a4",
	"./tourism/board.svg": "70c9",
	"./tourism/camping.svg": "18cb",
	"./tourism/caravan_park.svg": "5a60",
	"./tourism/chalet.svg": "e3e9",
	"./tourism/guest_house.svg": "e6c5",
	"./tourism/guidepost.svg": "7883",
	"./tourism/hostel.svg": "1e65",
	"./tourism/hotel.svg": "2734",
	"./tourism/map.svg": "f4a7",
	"./tourism/motel.svg": "c2bc",
	"./tourism/museum.svg": "9d5e9",
	"./tourism/office.svg": "cd6b",
	"./tourism/picnic.svg": "5474",
	"./tourism/terminal.svg": "9e99",
	"./tourism/viewpoint.svg": "6bc0",
	"./tourism/wilderness_hut.svg": "5707"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b679";